<template>
  <div class="keyword-planner-action">
    <KeywordPlannerActionButton @click="showList" />

    <KeywordPlannerActionList
      :show="stage === keywordPlannerActions.LIST"
      @select="switchStage"
      @hide="hide"
    />

    <KeywordPlannerAddKeyword
      :show="stage === keywordPlannerActions.ADD_KEYWORD"
      @hide="hide"
      @back="showList"
    />

    <KeywordPlannerAddNegativeKeyword
      :show="stage === keywordPlannerActions.ADD_NEGATIVE"
      @hide="hide"
      @back="showList"
    />
  </div>
</template>

<script>
import KeywordPlannerActionButton from './KeywordPlannerActionButton';
import KeywordPlannerActionList from './KeywordPlannerActionList';
import KeywordPlannerAddKeyword from './KeywordPlannerAddKeyword';
import KeywordPlannerAddNegativeKeyword from './KeywordPlannerAddNegativeKeyword';

import { keywordPlannerActions } from './common/constants';

export default {
  name: 'KeywordPlannerAction',
  components: {
    KeywordPlannerActionButton,
    KeywordPlannerActionList,
    KeywordPlannerAddKeyword,
    KeywordPlannerAddNegativeKeyword,
  },
  data() {
    return {
      stage: '',
    };
  },
  computed: {
    keywordPlannerActions() {
      return keywordPlannerActions;
    },
  },
  methods: {
    showList() {
      this.switchStage(keywordPlannerActions.LIST);
    },
    hide() {
      this.switchStage('');
    },
    switchStage(stage) {
      if (stage === keywordPlannerActions.LIST) {
        this.stage = keywordPlannerActions.LIST;
      } else if (stage === keywordPlannerActions.ADD_KEYWORD) {
        this.stage = keywordPlannerActions.ADD_KEYWORD;
      } else if (stage === keywordPlannerActions.ADD_NEGATIVE) {
        this.stage = keywordPlannerActions.ADD_NEGATIVE;
      } else if (!stage) {
        this.stage = '';
      }
    },
  },
};
</script>

<style lang="scss">
.keyword-planner-action {
  position: relative;
}
</style>
